module.exports = __webpack_public_path__ + "img/bools-title-02.950905b2.png";